import { createContext } from "react";

const ComboContext = createContext();

export default ComboContext;
